import type { HeroContentInput } from '../domain/value-objects/HeroContent.vo';

/**
 * Static content source for the Home Hero section.
 *
 * Per explicit product decision: only the structure/wiring was requested
 * for this pass — final marketing copy will be supplied and will replace
 * these values directly in this single file. The values below are limited
 * to facts already established (company name, sector), not composed
 * marketing claims, so the app has no fabricated content in the meantime.
 *
 * Replace `headline`, `subheadline`, and `ctaLabel` with the approved copy
 * when it is ready — no other file needs to change.
 */
export const homeHeroContent: HeroContentInput = {
  headline: 'داریوش معدن آذر',
  subheadline: 'شرکت فعال در حوزه‌ی استخراج و فرآوری مواد معدنی',
  ctaLabel: 'تماس با ما',
  ctaHref: '/contact'
};
